<div class="page-header-container">
  <div class="container-fluid">
    <div class="page-header-breadcrumbs">
      <ng-content select="[breadcrumbs]"></ng-content>
    </div>
  </div>
  <div class="page-header">
    <div class="container-md container-md-fluid">
      <div *ngIf="showEmblemLogotype" class="row py-5">
        <div class="col-12">
          <img
            class="emblem mb-4"
            [src]="
              './assets/img/logotypes/' +
              themeService.brand +
              '-emblem-page-header.svg'
            "
            alt="brand logo"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <ng-content select="[header]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
